import React from 'react';
import styled from 'styled-components';
import TidalDashboardWebhookGlobalStats from './TidalDashboardWebhookGlobalStats';

const TidalDashboardWebhooksHeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.6fr 0.6fr 0.6fr;
  grid-gap: 0 16px;
  align-items: center;
  padding: 22px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  @media only screen and (max-width: 1030px) {
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 8px;
  }
  @media only screen and (max-width: 786px) {
    grid-template-columns: 1fr;
    grid-gap: 8px 0;
  }
`;

const TidalDashboardWebhooksHeaderTitle = styled.div`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${(props) => props.theme.colors.text[1]};
  @media only screen and (max-width: 1030px) {
    display: none;
  }
`;

const TidalDashboardWebhooksHeaderTitleMobile = styled.div`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${(props) => props.theme.colors.text[1]};
  display: none;
  padding-top: 22px;
  @media only screen and (max-width: 1030px) {
    display: block;
  }
`;

interface TidalDashboardWebhooksHeaderProps {
  title: string;
  items: any[];
}

const TidalDashboardWebhooksHeader = ({
  title,
  items,
}: TidalDashboardWebhooksHeaderProps): JSX.Element => {
  return (
    <>
      <TidalDashboardWebhooksHeaderTitleMobile>
        {title}
      </TidalDashboardWebhooksHeaderTitleMobile>
      <TidalDashboardWebhooksHeaderWrapper>
        <TidalDashboardWebhooksHeaderTitle>
          {title}
        </TidalDashboardWebhooksHeaderTitle>

        {items.map((item: any, key) => (
          <TidalDashboardWebhookGlobalStats
            key={key}
            type={item.type}
            text={item.text}
            count={item.count}
            Icon={item.Icon}
          />
        ))}
      </TidalDashboardWebhooksHeaderWrapper>
    </>
  );
};

export default TidalDashboardWebhooksHeader;
